import { forwardRef, TextareaHTMLAttributes } from 'react'

import './style.scss'
import { Icon } from '..'

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string,
  fullWidth?: boolean,
  error?: boolean,
  version?: '2' | '3' | '',
  icon?: string
}

type Ref = HTMLTextAreaElement;

const CTextarea = forwardRef<Ref, TextareaProps>(({ className = '', fullWidth = false, error = false, version = '', icon = '', ...rest }, ref) => {
  return(
    <textarea ref={ref} className={`textarea ${version ? 'textarea--v' + version : ''} ${fullWidth ? 'w-full' : ''} ${error ? 'textarea--error' : ''} ${className}`} {...rest} />
  )
})

const Textarea = forwardRef<Ref, TextareaProps>(({ className = '', fullWidth = false, error = false, version = '', icon = '', ...rest }, ref) => {
  return (
    <>
      {icon ?
          <div className={`textarea-icon-wrapper ${className}`}>
            <Icon name="search" className="textarea-icon" />
            <CTextarea ref={ref} fullWidth={fullWidth} error={error} version={version} {...rest} />
          </div>
        :
          <CTextarea ref={ref} fullWidth={fullWidth} error={error} version={version} className={className} {...rest} />
      }
    </>
  )
})

export { Textarea }